import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('accounts/user');
  }
}

export default new API();
